import React, {useEffect, useRef, useState} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";



export default function DialogComp({text, head}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  }

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const {current: descriptionElement} = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Button onClick={handleClickOpen} variant={"contained"} color={"secondary"} size={"large"} sx={{textTransform: "uppercase"}}>
        {head}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        maxWidth={"lg"}
        fullWidth
      >
        <DialogTitle id="scroll-dialog-title">{head}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {text}
          </DialogContentText>
        </DialogContent>

      </Dialog>
    </div>
  );
}





